import Seo from "@/components/seo/Seo";
import PageHero from "@/components/layout/PageHero";

export default function LegalLayout({ title, path, description, updated, sections }) {
    return (
        <>
            <Seo title={title} path={path} description={description} noindex />
            <PageHero eyebrow="Dokumenty prawne" title={title} subtitle={`Ostatnia aktualizacja: ${updated}`} />
            <article className="py-14 lg:py-20">
                <div className="container-gr max-w-3xl">
                    {sections.map((s, i) => (
                        <section key={i} className="mt-10 first:mt-0">
                            <h2 className="text-xl tracking-tight text-foreground sm:text-2xl">{s.h}</h2>
                            {s.p.map((p, j) => (
                                <p key={j} className="mt-4 text-base leading-relaxed text-muted-foreground">{p}</p>
                            ))}
                        </section>
                    ))}
                    <p className="mt-12 rounded-2xl border border-border bg-gr-surface2 p-5 text-sm text-muted-foreground dark:bg-gr-dsurface2">
                        To dokument poglądowy dla strony marketingowej. Przed premierą zostanie zastąpiony ostateczną wersją zweryfikowaną prawnie.
                    </p>
                </div>
            </article>
        </>
    );
}
